/**
 * Data
 * ----
 */

/* Imports */

import React from "react";
import { StaticImage } from "gatsby-plugin-image";

/* Speakers and faqs */

const speakerPath = `../../../../static/latercon/2021/img/speakers/`;

const speakers = [
  {
    type: "b1",
    img: (
      <StaticImage
        src={`${speakerPath}valeria.jpg`}
        alt=""
        quality={75}
        placeholder="none"
      />
    ),
    name: "Valeria Lipovetsky",
    title: "Founder, Verie",
    links: [
      ["@valerialipvetsky", "https://www.instagram.com/valerialipovetsky/"],
      ["@shopverie", "https://www.instagram.com/shopverie/"],
    ],
    link: "",
  },
  {
    type: "b2",
    img: (
      <StaticImage
        src={`${speakerPath}brandon.jpg`}
        alt=""
        quality={75}
        placeholder="none"
      />
    ),
    name: "Brandon Smithwrick",
    title: "Senior Content Strategist, Squarespace",
    links: [["@raisedbystyle", "https://www.instagram.com/raisedbystyle/"]],
    link: "",
  },
  {
    type: "b3",
    img: (
      <StaticImage
        src={`${speakerPath}babba.jpg`}
        alt=""
        quality={75}
        placeholder="none"
      />
    ),
    name: `<span role="text">Babba <span class="lc-br-l">Rivera</span></span>`,
    title: "Founder of Ceremonia",
    links: [
      ["@babba", "https://www.instagram.com/babba/"],
      ["@myceremonia", "https://www.instagram.com/myceremonia/"],
    ],
    link: "",
  },
  {
    type: "b4",
    img: (
      <StaticImage
        src={`${speakerPath}alex.jpg`}
        alt=""
        quality={75}
        placeholder="none"
      />
    ),
    name: "Alex Lieberman",
    title: "Co-Founder, Morning Brew",
    links: [["@businessbarista", "https://twitter.com/businessbarista"]],
    link: "",
  },
  {
    type: "b1",
    img: (
      <StaticImage
        src={`${speakerPath}lily.jpg`}
        alt=""
        quality={75}
        placeholder="none"
      />
    ),
    name: "Lily Yange",
    title: "Content Creator",
    links: [["@lilyyange", "https://www.instagram.com/lilyyange/"]],
    link: "",
  },
  {
    type: "b5",
    img: (
      <StaticImage
        src={`${speakerPath}felicia.jpg`}
        alt=""
        quality={75}
        placeholder="none"
      />
    ),
    name: "Felicia Ip",
    title: "Founder, Designs by Felicia",
    links: [
      ["@designsbyfelicias", "https://www.instagram.com/designsbyfelicias/"],
    ],
    link: "",
  },
];

const faqs = [
  {
    expanded: true,
    title: "Why should I attend LaterCon?",
    content: (
      <>
        <p>
          In a nutshell: LaterCon is designed to help you grow on social media.
          So whether you're totally new to managing an Instagram account, or
          you're a pro looking for new strategies to try, we'll have something
          for you.
        </p>
        <p>
          And it's totally free &mdash; meaning no hefty price tag, and no
          travel or time off required.
        </p>
        <p>
          You'll get to hear from social marketing pros for $0, wherever works
          best for you.
        </p>
        <p>See you there?</p>
      </>
    ),
  },
  {
    title:
      "How do I watch the sessions? What if I can’t attend on September 29th?",
    content: (
      <>
        <p>
          LaterCon is (and always has been) fully digital — not that we’re
          bragging or anything.
        </p>
        <p>
          Tune in live on September 29th at 8 AM PT (11 AM ET) from your home
          office, couch, bed, patio&hellip;wherever you’ve got a good internet
          connection.
        </p>
        <p>
          When you sign up for a ticket, we’ll send you a link to join the
          conference beforehand.
        </p>
        <p>
          And if you can't make it &mdash; no worries, we understand the timing
          may not work. If you have a ticket, you'll receive the recorded
          sessions after the conference &mdash; delivered straight to your
          Inbox.
        </p>
        <p>
          But keep in mind that there are special perks to attending live, so
          drop in for a session or two if you can!
        </p>
      </>
    ),
  },
  {
    title: "I signed up but didn’t get a confirmation email. Help!",
    content: (
      <>
        <p>
          Be sure to check your spam/junk folder. If you don’t see anything, try
          updating your email preferences{" "}
          <a href="https://later.com/email-resubscribe">here</a>.
        </p>
      </>
    ),
  },
  {
    title: "What’s a digital conference?",
    content: (
      <>
        <p>Exactly what you think &mdash; but better.</p>
        <p>
          You can expect all the same perks of an IRL conference like meeting
          new people, chatting with experts, and watching interesting
          presentations &mdash; only this time, it'll be delivered to your
          screen.
        </p>
        <p>And yes, there will be swag!</p>
      </>
    ),
  },
  {
    title: "What will I learn?",
    content: (
      <>
        <p>
          Don’t expect any generic (or worse, outdated!) advice here. We’re
          bringing you detailed, actionable strategies you can actually use,
          with real-life examples to prove it.
        </p>
        <p>
          Our speakers have a wide range of experience — from managing social
          for your favorite brands to building their own influencer empires.
          They know how to build amazing social strategies across multiple
          platforms, and they’re going to share it with you.
        </p>
      </>
    ),
  },
  {
    title: "Is LaterCon actually free?",
    content: (
      <>
        <p>
          Yes and yes. Getting a ticket only requires your name and email — no
          credit card, and no need to create a Later account.
        </p>
        <p>
          In fact, LaterCon might be better than free, because we have some
          super special offers planned for attendees.
        </p>
      </>
    ),
  },
  {
    title: "I’m stoked. How do I share this excitement with my pals?!",
    content: (
      <>
        <p>
          Well aren’t you thoughtful! If you want to create some buzz
          before/during the conference, use #LaterCon in your posts, and don’t
          forget to tag @latermedia.
        </p>
        <p>P.S. There may be some sweet prizes for those who share!</p>
      </>
    ),
  },
  {
    title: "Okay, I’m sold. Where do I get a ticket?",
    content: (
      <>
        <p>
          Keep scrolling.
          <span role="img" aria-label="Index finger pointing downward">
            👇
          </span>
        </p>
      </>
    ),
  },
];

/* Export */

export { speakers, faqs };
